import { useEffect } from 'react';

import { useNavigationType } from 'react-router';

import { Routes } from '@/_navigation';
import { useBoolean } from '@/_shared';

interface IProps {
  resolvedCurrentPath: string;
  updateServer: () => void;
  paramLeadId?: string;
}

const validPaths = [
  Routes.INVESTMENT.link,
  Routes.PAYMENT_OPTIONS.link,
  Routes.CHECKOUT.link,
  Routes.BRIDGE_PLAN.link,
  Routes.TERMS.link,
];

export default function useDataSaving({ resolvedCurrentPath, updateServer, paramLeadId }: IProps) {
  const [isServerUpdateRequired, serverUpdateRequired] = useBoolean();
  const navType = useNavigationType();
  /**
   * Path Validation
   */
  useEffect(() => {
    if (navType === 'PUSH' && paramLeadId && validPaths.includes(resolvedCurrentPath)) {
      updateServer();
    }
  }, [resolvedCurrentPath, navType, paramLeadId, updateServer]);

  /**
   * Update server
   */
  useEffect(() => {
    if (isServerUpdateRequired) {
      updateServer();
      serverUpdateRequired.setFalse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isServerUpdateRequired]);

  return { serverUpdateRequired };
}
